export const SHOP_PAGE_NUM = 3; // 一页店铺数量

export const SZ_ORDER_STATUS = {
  EFFECTING: 1, // 生效中
  INVALID: 0, // 服务过期或未订购
};

export const SHOP_TYPE = {
  POP: 0, // pop
  JINGXI: 1, // 京喜
};

export const DATA_TYPE = {
  AMOUNT: 1, // 成交金额
  ORDER_NUM: 2, // 成交总单量
  ORDER_CUS_NUM: 3, // 成交客户数
  VISITOR_NUM: 4, // 访客数
};

export const Identity = {
  SuperAdmin: 1, // 超级管理员
  Employee: 2, // 员工
};
